import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";
const API = `${API_BASE}/api/auth`;
const TOKEN_KEY = "vf_token";
const USER_KEY  = "vf_user";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; }
  });

  const signup = async (name, email, password) => {
    const r = await fetch(`${API}/signup`, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({ name, email, password }),
    });
    const d = await r.json();
    if (!r.ok) return { error: d.error || "Signup failed." };
    localStorage.setItem(TOKEN_KEY, d.token);
    localStorage.setItem(USER_KEY, JSON.stringify(d.user));
    setUser(d.user);
    return { ok: true };
  };

  const login = async (email, password) => {
    const r = await fetch(`${API}/login`, {
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({ email, password }),
    });
    const d = await r.json();
    if (!r.ok) return { error: d.error || "Login failed." };
    localStorage.setItem(TOKEN_KEY, d.token);
    localStorage.setItem(USER_KEY, JSON.stringify(d.user));
    setUser(d.user);
    return { ok: true };
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  };

  const getToken = () => localStorage.getItem(TOKEN_KEY);

  return (
    <AuthContext.Provider value={{ user, login, signup, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
